import request from "@/utils/request.js"

/*运营平台*/
// 订单列表
export const listMallGoodsOrder = (pageData, formData) => {
    return request.post(`/mall-goods/order/${pageData.page}/${pageData.pageSize}`, formData)
}

// 订单数量统计
export const getMallGoodsOrderCount = () => {
    return request.post(`/mall-goods/order/count`)
}

// 发货
export const shipmentsMallGoodsOrder = (updateData) => {
    return request.put('/mall-goods/order/shipments', updateData)
}

// 批量上传物流订单号
export const updateBatchOrderNo = (formData) => {
    return request.put(`/mall-goods/order/upload/logistics/record`, formData)
}

// 是否存在物流记录
export const existMallGoodsOrderLogisticsRecord = () => {
    return request.post(`/mall-goods/order/logistics/record/exist`)
}

// 物流记录列表
export const listMallGoodsOrderLogisticsRecord = (pageData, formData) => {
    return request.post(`/mall-goods/order/logistics/record/page/${pageData.page}/${pageData.pageSize}`, formData)
}

// 取消批量发货
export const cancelMallGoodsOrderLogisticsShipments = () => {
    return request.delete(`/mall-goods/order/logistics/record/shipments`)
}

// 批量发货
export const shipmentsBatchMallGoodsOrderLogistics = () => {
    return request.put(`/mall-goods/order/logistics/record/shipments`)
}

// 订单详情
export const detailMallGoodsOrder = (orderId) => {
    return request.get(`/mall-goods/order/${orderId}`)
}

// 售后订单列表
export const listMallGoodsOrderAfterSale = (pageData, formData) => {
    return request.post(`/mall-goods/order/afterSale/${pageData.page}/${pageData.pageSize}`, formData)
}

// 售后订单类型
export const getMallGoodsOrderAfterSaleType = () => {
    return request.get(`/mall-goods/order/afterSale/type`)
}

// 售后订单详情
export const detailMallGoodsOrderAfterSale = (refundId) => {
    return request.post(`/mall-goods/order/afterSale/${refundId}`)
}

/*商家平台*/
// 订单列表
export const listMallGoodsOrderMerchant = (pageData, formData) => {
    return request.post(`/merchant/mall-goods/order/${pageData.page}/${pageData.pageSize}`, formData)
}

// 订单数量统计
export const getMallGoodsOrderCountMerchant = () => {
    return request.post(`/merchant/mall-goods/order/count`)
}

// 发货
export const shipmentsMallGoodsOrderMerchant = (updateData) => {
    return request.put('/merchant/mall-goods/order/shipments', updateData)
}

// 批量上传物流订单号
export const updateBatchOrderNoMerchant = (formData) => {
    return request.put(`/merchant/mall-goods/order/upload/logistics/record`, formData)
}

// 是否存在物流记录
export const existMallGoodsOrderLogisticsRecordMerchant = () => {
    return request.post(`/merchant/mall-goods/order/logistics/record/exist`)
}

// 物流记录列表
export const listMallGoodsOrderLogisticsRecordMerchant = (pageData, formData) => {
    return request.post(`/merchant/mall-goods/order/logistics/record/page/${pageData.page}/${pageData.pageSize}`, formData)
}

// 取消批量发货
export const cancelMallGoodsOrderLogisticsShipmentsMerchant = () => {
    return request.delete(`/merchant/mall-goods/order/logistics/record/shipments`)
}

// 批量发货
export const shipmentsBatchMallGoodsOrderLogisticsMerchant = () => {
    return request.put(`/merchant/mall-goods/order/logistics/record/shipments`)
}

// 订单详情
export const detailMallGoodsOrderMerchant = (orderId) => {
    return request.get(`/merchant/mall-goods/order/${orderId}`)
}

// 售后订单列表
export const listMallGoodsOrderAfterSaleMerchant = (pageData, formData) => {
    return request.post(`/merchant/mall-goods/order/afterSale/${pageData.page}/${pageData.pageSize}`, formData)
}

// 售后订单类型
export const getMallGoodsOrderAfterSaleTypeMerchant = () => {
    return request.get(`/merchant/mall-goods/order/afterSale/type/count`)
}

// 售后订单详情
export const detailMallGoodsOrderAfterSaleMerchant = (refundId) => {
    return request.post(`/merchant/mall-goods/order/afterSale/${refundId}`)
}
